'use strict';

function viewQuestionDetailsDirective() {
  return {
    restrict: 'A',
    scope: {
      answers: '&openQuestionDetails',
      question: '=questionData'
    },

    link: function(scope, elem) {
      elem.on('click', function(e) {
        e.preventDefault();

        var q = scope.question;

        var content =
          '<div class="answer-details__wrap">' +
            '<p class="answer-details__label">' + 'Displaying details for:' + '</p>' +
            '<h4 class="answer-details__header">' + q.title + '</h4>' +
            '<div class="row"><p class="question__description">' + q.description + '</p></div>' +

            '<ol class="answer-details__list">' +
              '<li class="answer-details__answer">' + scope.answers().filter(function(a) {
                return !!a.value;
              }).map(function(a) {
                return a.value;
              }).join('</li><li class="answer-details__answer">') + '</li>' +
            '</ol>' +
          '</div>';

        jQuery.fancybox.open({
          type: 'iframe',
          iframe: {
            preload: false
          },
          padding: 0,
          margin: [15, 5, 0, 5],
          content: content
        });
      });
    }
  };
}

angular.module('dokiv')
  .directive('openQuestionDetails', viewQuestionDetailsDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/forms/viewQuestionDetailsDirective.js
// module id = 354
// module chunks = 0